export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/abstract_pattern.1e37735.svg";